import type { NotificationFrequency } from '@/types';

/**
 * Get progress bar label with percentage and hours used
 */
export const getProgressBarLabel = (
  usedDataProcHours: number,
  usedDataProcHoursPercentage: number
): string => {
  const hourLabel = usedDataProcHours === 1 ? 'hour' : 'hours';
  return `${usedDataProcHoursPercentage}% (${usedDataProcHours} ${hourLabel} used)`;
};

/**
 * Find notification frequency name by ID
 */
export const findNotificationFrequency = (
  notificationFrequencies: NotificationFrequency[],
  id: number
): string => {
  const item = notificationFrequencies.find((f) => f.id === id);
  return item?.frequency || '';
};

/**
 * Get available hours label (remaining or over limit)
 */
export const getAvailableDataProcHoursLabel = (
  usedDataProcHours: number,
  availableDataProcHours: number,
  dataProcHours: number
): string => {
  if (usedDataProcHours > dataProcHours) {
    return `${Math.abs(availableDataProcHours)} Hours Over`;
  }
  return `${availableDataProcHours} Hours Remaining`;
};

/**
 * Check if threshold is overdue (usage exceeds threshold)
 */
export const isThresholdOverdue = (
  usedDataProcHoursPercentage: number,
  thresholdPercentage: number
): boolean => {
  return usedDataProcHoursPercentage > thresholdPercentage;
};

/**
 * Email validation regex
 */
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Validate email address
 */
export const isValidEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email);
};
